/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import api from "../../../api/reminders";

const state = {
  reminders: [],
  formErrors: [],
  reminderTypes: [],
  showEventCreditMessage: false,
  bulkCreateError: null,
  bulkActionComplete: false,
  eventReminderCreditModalOpen: false
};

const actions = {
  async create({ commit }, reminder) {
    try {
      const response = await api.create(reminder);
      commit("createReminder", response.data);
      commit("setShowEventCreditMessage", false);
    } catch (error) {
      if (error.response) {
        commit("setFormErrors", error.response.data);
        throw new Error("Invalid reminder");
      }
    }
  },
  async bulkCreate({ commit }, reminders, creditAmount) {
    try {
      const response = await api.bulkCreate(reminders, creditAmount);

      commit("bulkCreateReminder", response.data.reminders);
      commit("setBulkActionComplete", true);
      commit("setShowEventCreditMessage", false);
    } catch (error) {
      commit("setBulkCreateError", true);
    }
  },
  async index({ commit, state }) {
    if (state.reminders.length) return;
    commit("setLoading", true, { root: true });
    const response = await api.index();
    commit("setLoading", false, { root: true });
    if (response) {
      commit("setReminders", response.data.reminders);
      commit("setReminderTypes", response.data.reminderTypes);
      commit("setShowEventCreditMessage", response.data.showEventCreditMessage);
    } else {
      // Handle error
    }
  },
  async delete({ commit }, reminder) {
    commit("deleteReminder", reminder);
    await api.delete(reminder.id);
  },
  async update({ commit }, reminder) {
    try {
      const response = await api.update(reminder.id, reminder);
      commit("replaceReminder", {
        reminder,
        newReminder: response.data
      });
    } catch (error) {
      if (error.response) {
        commit("setFormErrors", error.response.data);
        throw new Error("Invalid reminder");
      }
    }
  }
};

const mutations = {
  setReminders(state, reminders) {
    state.reminders = reminders;
  },
  createReminder(state, reminder) {
    state.reminders = [...state.reminders, reminder];
  },
  bulkCreateReminder(state, reminders) {
    state.reminders = [...reminders];
  },
  deleteReminder(state, reminder) {
    state.reminders = state.reminders.filter(rem => rem.id !== reminder.id);
  },
  replaceReminder(state, { reminder, newReminder }) {
    const index = state.reminders.findIndex(rem => rem.id === reminder.id);
    state.reminders.splice(index, 1, newReminder);
  },
  setFormErrors(state, formErrors) {
    state.formErrors = formErrors;
  },
  setReminderTypes(state, reminderTypes) {
    state.reminderTypes = reminderTypes;
  },
  setShowEventCreditMessage(state, showMessage) {
    state.showEventCreditMessage = showMessage;
  },
  setBulkActionComplete(state, flag) {
    state.bulkActionComplete = flag;
  },
  setBulkCreateError(state, flag) {
    state.bulkCreateError = flag;
  },
  setEventReminderCreditModalOpen(state, flag) {
    state.eventReminderCreditModalOpen = flag;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
